export const generalErrorMessage = 'Oops! Something went wrong';

export const fileUploadErrorMessage =
  'Oops! Something went wrong while uploading file';

export const LoginMessages = {
  extendedScreenMessage:
    'Multiple screens detected. Please disconnect any extra screens and continue using only one.',
  consultMessage:
    'I will not consult any external source. This test will be completed on my own based on logic and reasoning alone.',
  interviewConsultMessage:
    'I commit to maintaining the interview integrity and will not use unauthorized materials, tools, or unfair means.',
  instructionsTitle: 'Please read the below instructions carefully',
  cameraMessage: {
    allow: {
      title: 'This session will be recorded',
      message:
        'We will record your audio and video during this assessment, kindly allow the permissions to continue.',
    },
    enable: {
      title: 'How to Enable Camera and Microphone',
    },
    position: {
      title: 'Make Sure You are Facing the Camera',
      message: (
        companyName: string,
        termsOfServiceUrl: string,
        privacyPolicyUrl: string
      ) =>
        `By continuing, you agree to ${companyName}’s <a href="${termsOfServiceUrl}" target="_blank">Terms of Service</a>\n and <a href="${privacyPolicyUrl}" target="_blank">Privacy Policy</a>.`,
    },
    instructions: {
      messageOne:
        'Align your face to the circle and click "Capture your face" to continue.',
      messageTwo: "Ensure that you're in a well lit room",
      messageThree: 'Make sure that you have proper lighting on your face',
      messageFour: "Don't position yourself at corner of the screen",
    },
  },
};

export const assessmentMessages = {
  incompleteSubmissionMessage:
    'You haven’t submitted your video response yet. Submitting the assessment now will leave the video question unanswered, and you won’t be able to complete it later.',
  submitMessage:
    'Once submitted, you can no longer view or modify this assessment. Are you sure you are done and want to submit the assessment?',
  tabChangeMessage: 'A tab change was detected.',
  fullScreenMessage:
    'Please switch to full screen to continue with the assessment.',
  interviewFullScreenMessage:
    'Please switch to full screen to continue with the interview.',
  interviewTimerMessage: 'Interview will start in',
  unAttemptedTooltipMessage: 'Question Unattempted',
  attemptedTooltipMessage: 'Question Attempted',
  timerMessage: 'Assessment will start in',
  tabChangeMessageInFullScreen: 'Your tab switch has been noted.',
};

export const generalMessages = {
  thankyoumessage: 'Thank you for the feedback!',
  invalidLinkTitle: 'Oops!',
  invalidLinkMessage: "We can't seem to find the page you are looking for",
};

export const ratingPageMessages = {
  title: "You've finished your assessment. How was your experience?",
  goodMessage: 'What did you like about us?',
  badMessage: 'What can we do to improve your experience?',
};

export const interviewRatingPageMessages = {
  title: "You've finished your interview. How was your experience?",
  goodMessage: 'What did you like about us?',
  badMessage: 'What can we do to improve your experience?',
};
export const expiryPageMessages = {
  title: 'This assessment is currently not available',
  message:
    'Please contact your recruiter to enable the test. Once your recruiter enables the test, after that you will be able to take the test.',
};

export const networkErrorMessages = {
  lost: 'Network disconnected. Please check your connection.',
  retry: 'Trying to reconnect',
  failed: 'Failed to establish connection',
  found: 'Connected to network',
};

export const videoErrorMessages = {
  NotReadableError: {
    title: "Assessment can't use your camera",
    content:
      'Make sure that another application is not using your camera, you might then need to refresh your browser.',
  },
  NotFoundError: {
    title: "Can't find your camera",
    content:
      'Check your systems settings to make sure that a camera is available. If not, plug one in. You might then need to restart your browser.',
  },
};

export const videoMessages = {
  timeEndCodeRun: {
    title: 'Time Up',
    message:
      'Your assessment time has ended. Choose whether to keep your current video response or submit without it.',
    primaryCta: 'Keep Video',
    secondaryCta: 'Discard Video',
  },

  timeEndTextRun: {
    title: 'Time Up',
    message:
      'Your assessment time has ended. Choose whether to keep your current answer or submit without it.',
    primaryCta: 'Keep Answer',
    secondaryCta: 'Discard Answer',
  },
};

export const codeMessages = {
  languageChange: {
    title: 'Change Language',
    message:
      'Changing language will reset your current code. Do you want to continue?',
    primaryCta: 'Yes',
    secondaryCta: 'No',
  },
  codeReset: {
    title: 'Reset Code Confirmation',
    message:
      'Are you sure you want to clear the code? Once cleared, this cannot be undone.',
    primaryCta: 'Yes',
    secondaryCta: 'No',
  },
  timeEndCodeRun: {
    title: 'Time Up',
    message:
      'Your assessment time has ended. Choose whether to keep your current code or submit without it.',
    primaryCta: 'Keep Code',
    secondaryCta: 'Discard Code',
  },
  confirmSubmission: {
    title: 'Submit Code',
    message:
      'You wont be able to come back to this question once you submit. Do you want to submit?',
    primaryCta: 'Submit',
    secondaryCta: 'Cancel',
  },
};

export const navDesktopMessages = {
  videoRecordingInProgress:
    "You are attempting a video question. Please Answer it or mark it as incomplete to move to another question. You won't be able to attempt it again.",
  codeRunning:
    'Code evaluation is in progress and moving to another question is not allowed.',
  dirtyCodePopup: {
    title: 'Submit Code',
    message:
      'There are unsaved changes. If you will leave,changes will be discarded.',
    primaryLabel: 'Stay',
    secondaryLabel: 'Leave',
    showPrimaryLabel: true,
  },
  dirtyVideoPopup: {
    title: 'Submit Video',
    message:
      'If you navigate away from this video question without submitting your response, you will not be able to submit it later.\nAre you sure you want to leave?',
    primaryLabel: 'Stay On Video Question',
    secondaryLabel: 'Leave Question',
    showPrimaryLabel: true,
  },
  dirtyTextualPopup: {
    title: 'Submit Text',
    message:
      'You have some unsaved changes. You can save them for later or submit your answer for evaluation before moving ahead',
    primaryLabel: 'Submit answer',
    secondaryLabel: 'Save for later',
    showPrimaryLabel: true,
  },
};

export const interviewMessages = {
  endInterviewCodeNotDirtyPopup: {
    title: 'End Interview.',
    message: 'Are you sure you want to interview?',
    primaryCta: 'Yes',
    secondaryCta: 'No',
  },
  endInterviewCodeDirtyPopup: {
    title: 'Unsaved Code Detected.',
    message:
      'Before ending the interview, would you like to submit your code for evaluation?',
    primaryCta: 'Yes',
    secondaryCta: 'No',
  },
  endInterviewNotCapturingPopup: {
    title: 'End Interview.',
    message: 'Are you sure you want to end your interview?',
    primaryCta: 'Yes',
    secondaryCta: 'No',
  },
  endInterviewCapturingPopup: {
    title: 'Unsubmitted answer detected.',
    message:
      'Before ending the interview, would you like to submit your response?',
    primaryCta: 'Yes',
    secondaryCta: 'No',
  },
  networkErrorPopup: {
    title: 'Reconnecting to .',
    message:
      'Before ending the interview, would you like to submit your response?',
    primaryCta: 'Yes',
    secondaryCta: 'No',
  },
};
